import React from "react";
import { ShieldAlert, AlertTriangle } from "lucide-react";

/**
 * Phase QCM-EXT — admin-only chip that surfaces a customer's cached
 * FMCSA risk signal on the Customers + Rentals grids.
 *
 * Props:
 *   - risk: { level: "ok"|"warn"|"at_risk", reasons: string[] } | null
 *   - testId: optional data-testid override; defaults to "fmcsa-risk-chip-{level}"
 *
 * Renders nothing when ``risk`` is null/undefined or ``level === "ok"`` —
 * empty signal must NOT clutter the grid. Hover/title shows the reasons.
 */
export function FmcsaRiskChip({ risk, testId }) {
    if (!risk) return null;
    const level = risk.level || "ok";
    if (level === "ok") return null;
    const reasons = Array.isArray(risk.reasons) ? risk.reasons : [];
    const tooltip = reasons.length > 0 ? reasons.join(" · ") : "FMCSA risk flag";

    if (level === "at_risk") {
        return (
            <span
                data-testid={testId || "fmcsa-risk-chip-at_risk"}
                title={tooltip}
                className="inline-flex items-center gap-1 rounded-full bg-red-100 text-red-800 text-[10px] font-semibold px-2 py-0.5 ring-1 ring-inset ring-red-200"
            >
                <ShieldAlert size={10} /> At risk
            </span>
        );
    }
    // warn
    return (
        <span
            data-testid={testId || "fmcsa-risk-chip-warn"}
            title={tooltip}
            className="inline-flex items-center gap-1 rounded-full bg-amber-50 text-amber-900 text-[10px] font-semibold px-2 py-0.5 ring-1 ring-inset ring-amber-200"
        >
            <AlertTriangle size={10} /> Caution
        </span>
    );
}

export default FmcsaRiskChip;
